import React, { useState } from 'react';
import '../common/common.css';
import Loading from '../loading/loading';
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_FACES_API_BASE}/password/forgot`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email }),
        }
      );

      if (response.ok) {
        window.alert(
          'If this email is registered, you will receive password recovery instructions.'
        );
        navigate('/reset-password/confirm');
      } else {
        window.alert('An error occurred. Please try again later.');
      }
    } catch (error) {
      console.error('Error during password reset:', error);
      window.alert('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <div>
      <form onSubmit={handleSubmit} id="main-form" autoComplete="off">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </form>
    </div>
  );
}

export default ResetPassword;
